export function buildLiveUpdateEventSourceUrl(crewId: string): string {
  return `/live/getLiveUpdates/${crewId}`;
}
